<template>
  <v-card
    :width="width"
    class="d-flex flex-column transparent"
    flat
  >
    <div class="d-flex transparent">
      <card-avatar-single
        :fotoPerfil="fotoPerfil"
        :nombreUsuario="nombreUsuario"
        tamanioFoto="78px"
        @clickFoto="$router.push({name: 'Perfil'})"
      />
    </div>
    <div class="d-flex flex-column flex-basis-1 transparent" style="width: 100%;" v-if="puestoUsuario && $route.name === 'Inicio' || (!$vuetify.breakpoint.smAndDown && $route.name !== 'Banqueo')">
      <card-puesto
        :puesto="puestoUsuario"
        :usuarios="cantidadUsuarios"
        :width="$vuetify.breakpoint.mdAndUp ? '300px': '100%'"
        height="137px"
        :label="mes"
        :heightbar="heightbar"
        :widthbar="widthbar"
        color="white"
        class="align-self-center"
      ></card-puesto>
    </div>
    <div class="transparent d-none d-md-flex flex-column align-center justify-center mx-auto" :style="$vuetify.breakpoint.mobile ? 'width: 100%;': 'width: 280px'">
      <v-btn
        class="d-flex d-none d-none d-md-flex align-center justify-center my-2 mt-10 card-informacion card-informacion--boton"
        dark
        @click="bePremium"
      >
        Sé Premium
      </v-btn>
      <v-btn
        class="d-flex d-none d-none d-md-flex align-center justify-center my-2 mt-5 card-informacion"
        @click="changeActiveCuponPremiumModal"
      >Usar cupón</v-btn>
    </div>
    <modal-premium
      @aceptar="modalPremium = false"
      v-model="modalPremium"
    />
    <cupon-premium-modal
      v-model="cuponPremiumModal"
      @close="cuponPremiumModal = false"
    />
  </v-card>
</template>

<script>
import CardPuesto from '@/components/CardPuesto'
import CardAvatarSingle from '@/components/inicio/CardAvatarSingle'
import ModalPremium from '@/components/ModalPremium'
import CuponPremiumModal from '@/components/CuponPremiumModal.vue'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CardAvatar',
  inheritAttrs: false,
  components: { CardPuesto, CardAvatarSingle, ModalPremium, CuponPremiumModal },
  props: {
    nombreUsuario: String,
    fotoPerfil: String,
    width: String
  },
  data () {
    return {
      heightbar: '57px',
      widthbar: '54px',
      modalPremium: false,
      cuponPremiumModal: false,
      mes: moment().format('MMMM').toUpperCase()
    }
  },
  computed: {
    ...mapState('perfil', ['user', 'puestoUsuario']),
    ...mapState(['cantidadUsuarios'])
  },
  methods: {
    ...mapActions('perfil', ['fetchPuestoUsuario', 'fetchUser']),
    ...mapActions(['fetchCantidadUsuarios']),
    bePremium () {
      this.modalPremium = true
    },
    changeActiveCuponPremiumModal () {
      this.cuponPremiumModal = !this.cuponPremiumModal
    }
  },
  async mounted () {
    await this.fetchUser()
    await this.fetchPuestoUsuario()
    await this.fetchCantidadUsuarios()
  }
  // watch: {
  //   user: {
  //     async handler (user) {
  //       if (!user) {
  //         this.puestoUsuario = null
  //         return
  //       }
  //       const rankingResponse = await this.$http.get('api/ranking/por_tipo/?tipo=MENSUAL')
  //       const ranking = rankingResponse.data
  //       this.puestoUsuario = ranking.findIndex(item => item.user.id === this.user.id) + 1
  //     },
  //     immediate: true
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.card-informacion {
  width: 80%;
  border-radius: 40px;
  box-shadow: none !important;
  border: 1px solid #E5E5E5;
  min-height: 40px;
  text-transform: none !important;
  background-color: #FFF !important;
  cursor: pointer;
  &--boton {
    background: linear-gradient(90deg, rgba(31, 193, 208, 1) 0%, rgba(31, 193, 208, 1) 5%, rgba(4, 128, 218, 1) 90%);
    color: white;
  }
}
.transparent {
  background-color: transparent!important;
 }
</style>
